"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var CloseButton = /** @class */ (function (_super) {
    tslib_1.__extends(CloseButton, _super);
    function CloseButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseButton.prototype.render = function () {
        var _a = this.props, className = _a.className, onClick = _a.onClick;
        return (react_1["default"].createElement(Wrapper, { className: className, onClick: onClick },
            react_1["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32" },
                react_1["default"].createElement("path", { d: "M29.3 0L16 13.3 2.7 0 0 2.7 13.3 16 0 29.3 2.7 32 16 18.7 29.3 32l2.7-2.7L18.7 16 32 2.7 29.3 0z" }))));
    };
    return CloseButton;
}(react_1.Component));
exports["default"] = CloseButton;
var templateObject_1;
